/**
 * Where the member app solves Turnstile.
 *
 * The iOS shell serves the bundle from `capacitor://localhost`, where the widget renders
 * but fails every challenge (600010), so on iOS it frames `turnstile.html` from the
 * hosted member app instead — see `@elyxeer/ui/turnstile-bridge`. The token then carries
 * the hosted hostname, which the widget and the API already allow. Android serves
 * `http://localhost` (`androidScheme` in capacitor.config.ts), which Turnstile accepts,
 * and the web is on its own origin, so both keep the widget in-page.
 *
 * The hosted app must already serve the bridge page when an iOS build that relies on it
 * ships: the shell loads it from `VITE_MEMBER_APP_URL`, not from its own bundle.
 */

import { platform } from "~/lib/capacitor";

export const TURNSTILE_BRIDGE_PATH = "/turnstile.html";

/** The bridge page to frame, or `undefined` where the widget runs in-page. */
export function turnstileBridgeUrl(): string | undefined {
  if (platform() !== "ios") return undefined;
  const memberAppUrl = import.meta.env.VITE_MEMBER_APP_URL?.trim();
  if (!memberAppUrl) return undefined;
  try {
    return new URL(TURNSTILE_BRIDGE_PATH, memberAppUrl).toString();
  } catch {
    return undefined;
  }
}
